(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'tooltipify', [ '$window', '$document', 'LoggerFactory', 'isMobile', Tooltipify ]);


    /**
     * Transforms any element's attribute 'title' into on hover/click-triggered
     * tooltip.
     *
     * @attribute {boolean} popup ~ Whether or not should the tooltip behave
     * more like a pop up (shows/hides on click) rather than a tooltip
     * (shows/hides on mouse hover).
     * @attribute {string}  title ~ Required to generate a text for the tooltip.
     *
     * @param {ng.IWindowService} $window
     * @param {ng.IDocumentService} $document
     * @param {LoggerFactory} LoggerFactory
     * @param {*} isMobile 3rd party module that can detect if the client is
     * a mobile device.
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function Tooltipify(
        $window,
        $document,
        LoggerFactory,
        isMobile
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'TooltipifyDirective', false );


        /** @const */
        var TOOLTIP            = {
            ANIMATION_SPEED_IN_MS: 50,
            MAX_WIDTH:             400,
            CARET_SIZE:            20,
            ANIMATION_OFFSET:      10,
            PAGE_MARGIN:           20
        };


        /** @type {DOMElement} */
        var tooltipElement = null,
        viewPort           = angular.element( $window ),
        bodyElement        = angular.element( $document[ 0 ].body );


        /** @type {ng.IDirective} */
        var directiveConfig    = {
            restrict: 'A',
            scope: {
                popup: '<'
            },
            link:     link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} element
         * @param {ng.IAttributes} attrs
         */
        function link( $scope, element, attrs ) {





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @type {DOMElement} */
            var tooltipContent = null;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                if ( !tooltipElement ){
                    initGlobalTooltipElement();
                }

                // Accessiblity
                element.attr( 'tabindex', 0 );

                // Register events
                if ( $scope.popup ){
                    element.bind( 'click', toggleTooltip );
                    element.addClass( 'tooltip-popup' );
                } else {
                    bindMouseHovering();
                    bindAccessibilityFeatures();
                }
            })();


            /** @destructor */
            (function destroy(){
                element.on( '$destroy', function () {
                    element.unbind();
                    viewPort.unbind( 'click' );
                });
            })();





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function toggleTooltip( $event ){
                if ( !tooltipElement.is( ':visible' ) ){
                    viewPort.bind( 'click', onClickOutsideElements );
                    showTooltip( $event );
                } else {
                    viewPort.unbind( 'click' );
                    hideTooltip( $event );
                }
            }


            function onClickOutsideElements( $event ) {
                if ( $event.target != element[ 0 ] && $event.target != tooltipElement[ 0 ] ) {
                    toggleTooltip( $event );
                };
            }


            function bindAccessibilityFeatures() {
                element.bind( 'focus', showTooltip );
                element.bind( 'focusout', hideTooltip );
                element.bind( 'keydown', hideTooltipOnEscKey );
            }


            function bindMouseHovering() {
                element.bind( 'mouseenter', showTooltip );
                element.bind( 'mouseout', hideTooltip );
            }


            function hideTooltipOnEscKey( $event ) {
                var KEY_ESC_ID = 27;
                if ( $event.which === KEY_ESC_ID ) {
                    hideTooltip();
                    $event.preventDefault();
                    return false;
                }
            }


            function initGlobalTooltipElement() {
                tooltipElement = angular.element( '<div id="tooltip" role="tooltip" hidden></div>' );
                bodyElement.append( tooltipElement );
                tooltipElement.hide();

                // Register events
                viewPort.resize( positionTooltip );
            }


            function showTooltip( $event ) {
                tooltipContent  = attrs.title || null;

                // Mobile Safari *ONLY* quirk: https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
                if ( isMobile.apple.device ) {
                    bodyElement.css( 'cursor', 'pointer' );
                }

                element.removeAttr( 'title' ); // Remove title attribute to prevent default system behavior
                element.attr( 'aria-describedby', 'tooltip' );  // Accessibility
                tooltipElement.removeAttr( 'hidden' );          // Accessibility

                if ( !tooltipContent ){
                    logger.error( "Tooltip's description is missing. Tooltip will not be shown." );
                    return;
                }

                tooltipElement
                    .css( 'opacity', 0 )
                    .html( tooltipContent );

                tooltipElement.show();
                positionTooltip();

                return $event;
            }


            function hideTooltip( $event ) {
                tooltipElement
                    .animate({
                        top: '-=' + TOOLTIP.ANIMATION_OFFSET,
                        opacity: 0
                    }, 0 ); // default

                element.attr( 'title', tooltipContent );
                element.removeAttr( 'aria-describedby' );   // Accessibility
                tooltipElement.attr( 'hidden', 'hidden' );  // Accessibility

                // Mobile Safari *ONLY* quirk: https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
                if ( isMobile.apple.device ) {
                    bodyElement.css('cursor', null );
                }

                tooltipElement.hide();

                return $event;
            }


            function calculatePositionX() {
                var positionX = 0,

                caretOffset = 20, // Half of the caret size + margin from the edge of the tooltip

                pageWidth = viewPort.width(),
                elementCenterX = element.offset().left + element.outerWidth() / 2,

                potentialTooltipLeftPositionX = elementCenterX - caretOffset,
                potentialTooltipRightPositionX = elementCenterX - tooltipElement.outerWidth() + caretOffset;

                if ( ( pageWidth ) < ( potentialTooltipLeftPositionX + tooltipElement.outerWidth() ) && ( elementCenterX - caretOffset ) >= ( 0 ) ){
                    logger.debug( "Tooltip's LEFT caret won't fit, placing it RIGHT." );

                    tooltipElement.addClass( 'right' );
                    positionX = potentialTooltipRightPositionX;
                } else {
                    // Default
                    logger.debug( "Tooltip's LEFT caret does fit!" );

                    tooltipElement.addClass( 'left' )
                    positionX = potentialTooltipLeftPositionX;
                }

                return positionX;
            }


            // (Default: 'bottom')
            function calculatePositionY() {
                var positionY = 0,

                caretOffset = 16,  // Caret's height + margin between the tip and the element

                viewPortTopY = viewPort.scrollTop(),
                viewPortBottomY = viewPortTopY + viewPort.height(),

                elementTopY = element.offset().top,
                elementBottomY = elementTopY + element.outerHeight(),

                potentialTooltipTopPositionY = elementTopY - caretOffset - TOOLTIP.ANIMATION_OFFSET - tooltipElement.outerHeight(),
                potentialTooltipBottomPositionY = elementBottomY + caretOffset - TOOLTIP.ANIMATION_OFFSET;

                if ( potentialTooltipTopPositionY < ( viewPortTopY + TOOLTIP.PAGE_MARGIN  ) && ( elementBottomY + caretOffset + tooltipElement.outerHeight() ) <= viewPortBottomY - TOOLTIP.PAGE_MARGIN ) {
                    logger.debug( "Tooltip can only be positioned BELOW." );

                    tooltipElement.addClass( 'top' );
                    positionY = potentialTooltipBottomPositionY;
                } else {
                    // Default
                    logger.debug( "Tooltip can only be positioned ABOVE." );

                    tooltipElement.addClass( 'bottom' );
                    positionY = potentialTooltipTopPositionY;
                }

                return positionY;
            }


            function setWidth() {
                var expectedTooltipWidth = tooltipElement.outerWidth(),
                viewPortWidth = viewPort.width(),

                // 1. Determine whether it's better to be on left or right side
                caretOffset = 20, // Half of the caret size + margin from the edge of the tooltip

                elementCenterX = element.offset().left + element.outerWidth() / 2,

                potentialTooltipLeftPositionX = elementCenterX - caretOffset,
                potentialTooltipRightPositionX = elementCenterX - tooltipElement.outerWidth() + caretOffset,

                potentialTooltipLeftSpace = viewPortWidth - potentialTooltipLeftPositionX,
                potentialTooltipRightSpace = potentialTooltipRightPositionX + tooltipElement.outerWidth();

                // 2. Check if the tooltip is going to fit there
                if ( ( potentialTooltipLeftSpace - TOOLTIP.PAGE_MARGIN ) >= tooltipElement.outerWidth() || ( potentialTooltipRightSpace - TOOLTIP.PAGE_MARGIN ) >= tooltipElement.outerWidth() ){
                    tooltipElement.outerWidth( expectedTooltipWidth + 1 );
                    return;
                }

                if ( potentialTooltipLeftSpace < potentialTooltipRightSpace ){
                    // Tooltip right is better
                    tooltipElement.outerWidth( potentialTooltipRightSpace - TOOLTIP.PAGE_MARGIN );
                } else {
                    // Tooltip left is better
                    tooltipElement.outerWidth( potentialTooltipLeftSpace - TOOLTIP.PAGE_MARGIN );
                }
            }


            function positionTooltip() {
                tooltipElement.removeClass(); // Reset positioning classes
                tooltipElement.css( 'width', '' ); // Revert
                tooltipElement.css( 'height', '' ); // Revert

                setWidth();

                tooltipElement
                    .css({
                        left: calculatePositionX(),
                        top:  calculatePositionY()
                    })
                    .animate({
                        top: '+=' + TOOLTIP.ANIMATION_OFFSET,
                        opacity: 1
                    }, TOOLTIP.ANIMATION_SPEED_IN_MS );
            }


        }



    }
})();

